import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState, AuthActionTypes } from '@app/core/ngrx';
import { Router } from '@angular/router';
import { faExclamationTriangle, faSpinner } from '@fortawesome/free-solid-svg-icons';
/**
 * LoginFormComponent
 */
@Component({
  selector: 'ecp-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  standalone: false,
})
export class LoginFormComponent implements OnInit {
  /**
   * loginForm
   */
  loginForm: UntypedFormGroup;
  /**
   * error$
   */
  // @select(['auth', 'error'])
  error$: Observable<any>;
  /**
   * pending$
   */
  // @select(['auth', 'pending'])
  pending$: Observable<boolean>;

  /**
   * constructor
   * @param {Store<AppState>} store
   * @param {Router} router
   */
  constructor(private store: Store<AppState>, private router: Router) {}

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.error$ = this.store.pipe(select((state) => state.auth.error));
    this.pending$ = this.store.pipe(select((state) => state.auth.pending));
    this.loginForm = this.createForm();
  }

  /**
   * username
   * @returns {AbstractControl}
   */
  get username(): AbstractControl {
    return this.loginForm.get('username');
  }

  /**
   * password
   * @returns {AbstractControl}
   */
  get password(): AbstractControl {
    return this.loginForm.get('password');
  }

  /**
   * createForm
   * @returns {FormGroup}
   */
  createForm(): UntypedFormGroup {
    const username = new UntypedFormControl('', {
      validators: Validators.compose([Validators.required, Validators.email]),
    });

    const password = new UntypedFormControl('', {
      validators: Validators.compose([Validators.required, Validators.minLength(1)]),
    });

    return new UntypedFormGroup({ username, password }, { updateOn: 'submit' });
  }

  /**
   * onSubmit
   * @returns {boolean}
   */
  onSubmit() {
    // if (this.loginForm.valid) {
    //   this.store.dispatch({ type: AuthActionTypes.LOGIN });
    //   this.authService.login(this.loginForm.value).catch(err => {
    //     this.store.dispatch({
    //       type: AuthActionTypes.LOGIN_ERROR,
    //       payload: err,
    //     });
    //   });
    // }
    // return false;
  }
}
